module.exports = __webpack_public_path__ + "static/media/exhibition-services-img13.d4d4bc94.jpg";